(function () {

    ScheduleDateUtilsService.$inject = [];

    function ScheduleDateUtilsService() {
        var self = this;
        var cache = new Map();

        self.moment = function (date) {
            let dateObj = cache.get(date);

            if (!dateObj) {
                dateObj = moment(date);
                cache.set(date, dateObj);
            }

            return dateObj;
        };
    }

    app.service('scheduleDateUtilsService', ScheduleDateUtilsService);

}());